<div class="horizinns-container center">
    <mat-card class="horizinns-card more-blur white-blur mw-60">
        <mat-card-content>

            <div class="return-container" style="margin: 4rem auto; padding: 2rem; text-align: center;">
                <img src="/assets/images/logo_full_900.png" class="main-logo" alt="Horizinns logo" />
                  @if (loading()) {
                    <p>Loading payment status...</p>
                  } @else if (error()) {
                    <app-success-error [success]="false"></app-success-error>
                    <h2>🫩 Something went wrong</h2>
                    <p>{{ error() }}</p>
                    <button mat-raised-button color="primary" (click)="retry()">Try again</button>
                  } @else if (session()) {
                    @switch (session()!.payment_status) {
                      @case ('paid') {
                        <app-success-error [success]="true"></app-success-error>
                        <h2>Thank you for listing on Horizinns! 🎉</h2>
                        <p style="font-size:1.4rem;">Your payment of {{ formatAmount(session()!.amount_total!, session()!.currency!) }} was successful.</p>
                        <p style="font-size:1.2rem;">A confirmation email has been sent to {{ session()!.customer_email || 'your email' }}.</p>
                        <p style="font-size:1.2rem;">Order processing may take a few moments — we'll notify you soon.</p>
                      }
                      @case ('unpaid') {
                        <app-success-error [success]="false"></app-success-error>
                        <h2>Payment not completed</h2>
                        <p>Please try again or contact support if issues persist.</p>
                      }
                      @default {
                        <h2>Payment status: {{ session()!.payment_status }}</h2>
                        <p>We'll process your order shortly if payment succeeds.</p>
                      }
                    }
                  } @else {
                    <p>No session information available.</p>
                  }
            
                  <div style="margin-top: 2rem;">
                    <button mat-flat-button class="metallic-text-btn-blue" (click)="goToProperties()">
                        <mat-icon>home</mat-icon>
                        View Your Properties
                    </button>
                  </div>
                </div>
        </mat-card-content>
    </mat-card>
</div>
